import RiskLayout from "./RiskLayout";
export default function PRiskLayout() {
  return <RiskLayout basePath="/partner/portfoliomanagement/p/risk" />;
}
